import "./Logo.css";

export const Logo = () => {
  return (
    <div className="logo-box">
      <img className="logo" src={"/images/LOGO_MOBILE.svg"} alt="logo" />
    </div>
  );
};
